import { render, staticRenderFns } from "./NewEditAll.vue?vue&type=template&id=32778d34&"
import script from "../../models/push-notifications/new-edit-all.ts?vue&type=script&lang=ts&"
export * from "../../models/push-notifications/new-edit-all.ts?vue&type=script&lang=ts&"
import style0 from "./NewEditAll.vue?vue&type=style&index=0&id=32778d34&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports